import PropTypes from 'prop-types'
import React from 'react'

function BulkPrices({ product, t }) {
  if (!product.bulkPrices || product.bulkPrices.length === 0) {
    return null
  }

  return (
    <div className="product-addition">
      <h2 className="product-addition-headline">{t('components.productComponent.bulkPrices.title')}</h2>

      <dl className="product-addition-list-head">
        <dt>{t('components.productComponent.bulkPrices.quantity')}</dt>
        <dd>{t('components.productComponent.bulkPrices.price')}</dd>
      </dl>

      {product.bulkPrices
        .sort((a, b) => a.quantity.amount - b.quantity.amount)
        .map((bulkPrice) => (
          <dl key={bulkPrice.quantity.amount}>
            <dt>
              {t('components.productComponent.bulkPrices.itemQuantity', {
                quantity: bulkPrice.quantity.amount,
                unit: bulkPrice.quantity.unit,
              })}
            </dt>
            <dd>{bulkPrice.price.formatted}</dd>
          </dl>
        ))}
    </div>
  )
}

BulkPrices.propTypes = {
  product: PropTypes.shape({
    bulkPrices: PropTypes.arrayOf(
      PropTypes.shape({
        quantity: PropTypes.shape({
          amount: PropTypes.number,
          unit: PropTypes.string,
        }),
        price: PropTypes.shape({
          formatted: PropTypes.string,
        }),
      }),
    ),
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default BulkPrices
